module.exports = __webpack_public_path__ + "static/media/bannerBronzeBackground.9107f2e5.png";